import { Component, ElementRef, inject, ViewChild } from "@angular/core";
import { Router, RouterLink, RouterOutlet } from "@angular/router";
import { FooterComponent } from "./felles/components/footer/footer.component";
import { TranslateService } from "@ngx-translate/core";
import { HeaderComponent, MenuElement } from "@husbanken/designsystem-angular-header-v2";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  imports: [RouterLink, RouterOutlet, FooterComponent, HeaderComponent],
})
export class AppComponent {
  meny: MenuElement[] = MENY;

  @ViewChild("hovedinnhold")
  hovedinnhold: ElementRef;

  router = inject(Router);
  translateService = inject(TranslateService);

  constructor() {
    this.translateService.setDefaultLang("nb");
    this.translateService.use("nb");
  }

  gaaTilHovedinnhold() {
    this.hovedinnhold.nativeElement.focus();
  }

  finnUrl() {
    return this.router.url.toLowerCase().split("#")[0];
  }
}

const MENY: MenuElement[] = [
  {
    tekst: "Meny.Oversikt",
    link: "/",
  },
  {
    tekst: "Meny.Bostøtte",
    link: "/bostotte",
  },
  {
    tekst: "Meny.Lån",
    link: "/lan",
    submenu: [
      {
        tekst: "Meny.Boligkvalitet",
        link: "/lan/boligkvalitet",
      },
      {
        tekst: "Meny.Utleieboliglån",
        link: "/lan/utleieboliglan",
      },
      {
        tekst: "Meny.Studentbolig",
        link: "/lan/studentbolig",
      },
      {
        tekst: "Meny.Startlån",
        link: "/lan/startlan",
      },
      {
        tekst: "Meny.Grunnlån",
        link: "/lan/grunnlan",
      },
      {
        tekst: "Meny.Barnehagelån",
        link: "/lan/barnehagelan",
      },
    ],
  },
  {
    tekst: "Meny.Tilskudd",
    link: "/tilskudd",
    submenu: [
      {
        tekst: "Meny.Investeringstilskudd",
        link: "/tilskudd/investeringstilskudd",
      },
      {
        tekst: "Meny.TilskuddUtleie",
        link: "/tilskudd/utleiebolig",
      },
      {
        tekst: "Meny.TilskuddTilstand",
        link: "/tilskudd/tilstandsvurdering",
      },
      {
        tekst: "Meny.Kompetansetilskudd",
        link: "/tilskudd/kompetansetilskudd",
      },
      {
        tekst: "Meny.Energitilskudd",
        link: "/tilskudd/energitilskudd",
      },
    ],
  },
  {
    tekst: "Meny.Kommune",
    link: "/kommune",
    submenu: [
      {
        tekst: "Meny.Nokkeltall",
        link: "/kommune/nokkeltall",
      },
      {
        tekst: "Meny.Sammenligning",
        link: "/kommune/sammenligning",
      },
      {
        tekst: "Meny.Utvikling",
        link: "/kommune/utvikling",
      },
    ],
  },
  {
    tekst: "Meny.Datasett",
    link: "/datasett/datasett",
  },
  {
    tekst: "Meny.Hjelp",
    link: "/hjelp",
    submenu: [
      {
        tekst: "Meny.Komigang",
        link: "/hjelp/komigang",
      },
      {
        tekst: "Meny.Begreper",
        link: "/hjelp/begreper",
      },
      {
        tekst: "Meny.Om",
        link: "/hjelp/om",
      },
    ],
  },
];
